import { ToolbarCSSStyleImpl } from './toolbarcss';
import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { ToolbarViewImpl } from './toolbarview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { ToolbarAPIModelImpl } from './toolbarapimodel';
import { APIModelHandler, APIModel } from '../uicomponentapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { RoutingFeatures } from '../../components/navigation/routingfeature';

export interface ToolbarComponentProps extends UIComponentProps
{
    categories: CategoryDto[];
   onLogoClicked(): void;
   onSignInClicked():void;
   onCategoriesSelected(title: string): void;
   onDoItYourselfClicked(): void;
   onFlashMessageClicked(): void;
}

export interface ToolbarComponentHandler extends UIComponentHandler
{
    deselectAll(): void;
    onCategoriesSelected(title: string): void;
    onTunesSelected(isShow: boolean): void;
    onSignInClicked():void;
}

export interface ToolbarComponentState extends UIComponentState
{
   isTunesSelected: boolean;
   categories: CategoryDto[];
}


export class ToolbarComponent extends UIComponentImpl<ToolbarComponentProps, ToolbarComponentState, UIDataModel>
{
    constructor(props: ToolbarComponentProps)
    {
        super(props);

        this.state = {categories: this.props.categories, isTunesSelected: false};
    }

    componentDidMount()
    {
        // (this.getAPIModel() as ToolbarAPIModel).getCategories();
    }

    deselectAll()
    {
        this.setState({isTunesSelected: false});
    }

    componentWillReceiveProps(nextprops: ToolbarComponentProps)
    {
        this.setState({categories: nextprops.categories});
    }

    onTunesSelected(isShow: boolean): void 
    {
        this.setState({isTunesSelected: isShow});
    }

    onCategoriesSelected(title: string): void 
    {
        this.props.onCategoriesSelected(title);
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToolbarViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToolbarCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToolbarAPIModelImpl(applicationContext, apiModelHandler);
    }

    onSignInClicked():void
    {
        this.props.context.getRedirectionHandler().routeNextFeature(RoutingFeatures.LOGIN, false);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
      if(feature === APIFeatures.CATEGORIES)
        {
            console.log("-------listOfCategoriesDetails: " + JSON.stringify(data as CategoryDto[]));
            this.setState({categories: data as CategoryDto[]});
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbar/toolbarcomponent.tsx